// extracted by mini-css-extract-plugin
module.exports = {"container":"Success_container__VjXq6","icon":"Success_icon__17qDe","title":"Success_title__1UbaQ","hint":"Success_hint__34DtL","button":"Success_button__8hL7j"};